const headers = [{
    text: "Código do Contrato",
    align: "left",
    value: "contractCode"
  },
  {
    text: "Empresa",
    align: "center",
    value: "company",
    sortable: false
  },
  {
    text: "Cliente",
    align: "center",
    value: "client",
    sortable: false
  },
  {
    text: "Situação",
    align: "center",
    value: "status",
    sortable: false
  },
  {
    text: "Ações",
    align: "center",
    value: "name",
    sortable: false
  }
]
const budgetHeaders = [{
    text: "Código do Orçamento",
    align: "left",
    sortable: true,
    value: "code"
  },
  {
    text: "Empresa",
    align: "center",
    value: "company"
  },
  {
    text: "Tipo do Orçamento",
    align: "center",
    value: "tradingFloor"
  },
  {
    text: "Processo",
    align: "center",
    value: "process"
  },
  {
    text: "Cliente",
    align: "center",
    value: "client"
  },
  {
    text: "Data do Pregão",
    align: "center",
    value: "dateOfTheTradingFloor"
  }
]
const consumablesHeader = [{
    text: "Especificação / Descrição",
    align: "center",
    value: "description"
  },
  {
    text: "Unidade de Medida",
    align: "center",
    value: "unity"
  },
  {
    text: "Quantidade",
    align: "center",
    value: "quantity"
  },
  {
    text: "Valor Unitário",
    align: "center",
    value: "unitaryValue"
  },
  {
    text: "Sub-Total",
    align: "center",
    sortable: false
  },
  {
    text: "Vida Útil (mês)",
    align: "center",
    value: "lifetime"
  },
 /*  {
    text: "Valor Mensal",
    align: "center",
    value: "monthlyValue"
  }, */
  {
    text: "Ação",
    align: "center",
    sortable: false
  }
]
const equipmentsHeaders = [{
    text: "Especificação / Descrição",
    align: "center",
    value: "description"
  },
  {
    text: "Marca / Modelo",
    align: "center",
    value: "stamp"
  },
  {
    text: "Quantidade",
    align: "center",
    value: "quantity"
  },
  {
    text: "Valor Unitário",
    align: "center",
    value: "unitaryValue"
  },
  {
    text: "Sub-Total",
    align: "center",
    sortable: false
  },
  {
    text: "Vida Útil (%)",
    align: "center",
    value: "lifetime"
  },
 /*  {
    text: "Valor Mensal",
    align: "center",
    value: "monthlyValue"
  }, */
  {
    text: "Ação",
    align: "center",
    sortable: false
  }
]
const utencilHeaders = [{
    text: "Descrição / Especificação",
    align: "left",
    sortable: true,
    value: "description"
  },

  {
    text: "Unidade",
    align: "center",
    value: "unity"
  },
  
  {
    text: "Quantidade",
    align: "center",
    value: "quantity"
  },
  {
    text: "Valor Unitário",
    align: "center",
    value: "unitaryValue"
  },
  {
    text: "Sub-Total",
    align: "center",
    sortable: false
  },
  {
    text: "Vida Útil (mês)",
    align: "center",
    value: "lifetime"
  },
/*   {
    text: "Valor Mensal",
    align: "center",
    value: "monthlyValue"
  }, */
  {
    text: "Ações",
    align: "center",
    value: "name",
    sortable: false
  }
]
const uniformsAndEPIsHeaders = [{
    text: "Descrição / Especificação",
    align: "left",
    sortable: true,
    value: "description"
  },

  {
    text: "Unidade",
    align: "center",
    value: "unity"
  },
  {
    text: "Quantidade",
    align: "center",
    value: "quantity"
  },
  {
    text: "Valor Unitário",
    align: "center",
    value: "unitaryValue"
  },
  {
    text: "Sub-Total",
    align: "center",
    sortable: false
  },
  {
    text: "Vida Útil (mês)",
    align: "center",
    value: "lifetime"
  },
 /*  {
    text: "Valor Mensal",
    align: "center",
    value: "monthlyValue"
  }, */
  {
    text: "Ações",
    align: "center",
    value: "name",
    sortable: false
  }
]
class Headers {
  static getHeaders() {
    return headers
  }
  static getBudgetHeaders() {
    return budgetHeaders
  }
  static getConsumablesHeaders() {
    return consumablesHeader
  }
  static getEquipamentHeaders() {
    return equipmentsHeaders
  }
  static getUtencilHeaders() {
    return utencilHeaders
  }
  static getUniformsAndEPIsHeaders() {
    return uniformsAndEPIsHeaders
  }
}
export default Headers;



// WEBPACK FOOTER //
// ./src/data/headers/ContractHeaders.js